module.exports = __webpack_public_path__ + "img/collecplan.f7280618.png";